import { render, staticRenderFns } from "./DialogAtendimento.vue?vue&type=template&id=96654770"
import script from "./DialogAtendimento.vue?vue&type=script&lang=js"
export * from "./DialogAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports